import React from 'react';
import { ArrowRight } from 'lucide-react';

const SectionSeparator = ({ sectionNumber, title, description, onContinue }) => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4 sm:px-6 py-12">
      <div className="max-w-3xl text-center">
        {/* Section Number */}
        <div className="mb-6 sm:mb-8">
          <div
            className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full text-white text-2xl sm:text-3xl font-bold mb-3 sm:mb-4"
            style={{ background: 'linear-gradient(135deg, #7A00EB, #00c3ef)' }}
          >
            {sectionNumber}
          </div>
        </div>

        {/* Title */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#f5f5f5] mb-4 sm:mb-6 leading-tight px-2">
          {title}
        </h2>

        {/* Description */}
        <p className="text-base sm:text-lg md:text-xl text-[#a3a3a3] mb-8 sm:mb-12 leading-relaxed max-w-2xl mx-auto px-4">
          {description}
        </p>

        {/* Continue Button */}
        <button
          onClick={onContinue}
          className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-semibold text-white rounded-lg shadow-lg hover:shadow-xl transition-all hover:opacity-90 w-full sm:w-auto"
          style={{ background: 'linear-gradient(to right, #7A00EB, #00c3ef)' }}
        >
          Continue
          <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
        </button>

        {/* Progress Indicator */}
        <div className="mt-8 sm:mt-12 flex items-center justify-center gap-1.5 sm:gap-2">
          {[1, 2, 3, 4].map((num) => (
            <div
              key={num}
              className={`h-1.5 sm:h-2 rounded-full transition-all ${
                num <= sectionNumber ? 'w-8 sm:w-12' : 'w-1.5 sm:w-2'
              }`}
              style={{
                background: num <= sectionNumber
                  ? 'linear-gradient(to right, #7A00EB, #00c3ef)'
                  : '#262626'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionSeparator;
